export const STAKING_STEP_ONE = 0
export const STAKING_STEP_TWO = 1
export const STAKING_STEP_THREE = 2
export const STAKING_STEP_FOUR = 3
